import { getRunTime } from '../../../public-resource/libs/utils/index'
let protocol = window.location.protocol

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let QAAPI_HOST = getRunTime('//qaapi.xinli001.com')
let YIAPI_HOST = getRunTime('//yiapi.xinli001.com')
let STATIC = protocol + getRunTime('//static.xinli001.com')
// HOST = '//m-qc1.xinli001.com'
// YIAPI_HOST = '//yiapi-qc1.xinli001.com'
// QAAPI_HOST = '//qaapi-qc1.xinli001.com'
let IS_APP = window.$platform.isYixinliApp

module.exports = {
  host: protocol + HOST,
  isLogin: `${HOST}/ajax/get-user-header`,
  levelPopup: `${HOST}/qa/qa-api/popup-window`, // 等级弹窗
  getWXShareConfig: `${HOST}/wx/get-wx-package.json`,
  cantonalRecommend: `${QAAPI_HOST}/cantonal/recommend`,
  getQaData: `${HOST}/qa/get-qa-tag-data-list.json`, // 数据获取
  login: IS_APP
    ? 'yixinli://open_user_login'
    : `${HOST}/account/login?next=${encodeURIComponent(
        protocol + HOST + location.pathname + location.search + location.hash
      )}`,
  sameFeel: `${HOST}/qa/qa-same-feeling-toggle.json`, // 同感接口
  likeQuestion: `${HOST}/qa/like-question-answer.json`, // 点赞接口
  answerReplay: `${HOST}/qa/post-answer-reply.json`, // 回答问题
  storeQuestion: `${HOST}/qa/store-question.json`, // 关注问题
  noticesToggle: `${HOST}/qa/change-qa-notices-toggle.json`, // 关注问题清0
  followAttention: `${HOST}/ajax/user-follow-toggle1.json`, // 关注用户
  getQaFocusNotices: `${HOST}/qa/get-qa-focus-notices.json`, // 关注用户
  getQaReply: `${HOST}/qa/get-answer-reply-list.json`, // 关注用户
  getADList: `${YIAPI_HOST}/v5/yi/get-ad-lists.json`, // 获取广告流
  latestQuestion: `${HOST}/qa/get-latest-question.json`, // 新问题接口
  getUserNotice: `${HOST}/qa/get-user-notice.json`, // 顶部消息通知
  clearInviteNum: `${HOST}/qa/clear-user-invite-num.json`, // 清除被邀请回答数
  getRankList: `${HOST}/qa/answer-ranking-list`, // 实时榜单
  getInviteNum: `${HOST}/qa/get-user-invite-num.json`, // 获取用户剩余问答邀请数
  postQuestion: `${HOST}/qa/post-question-view`, // 向ta提问
  qaBranchList: `${STATIC}/msite/index.html#/qaBranchList`, // 分管列表页
  qaBranchAdmin: `${STATIC}/msite/index.html#/qaBranchAdmin?cantonalId=`, // 分管管理页
  inviteList: `${HOST}/qa/invitation-list`, // 还能邀答
  joinBranch: `${QAAPI_HOST}/cantonal/join-cantonal`, // 加入分馆
  showPlacard: '//marketing.xinli001.cc/api/placard/image/fenguan', // 分馆海报
  rankList: `${QAAPI_HOST}/cantonal/example-list`, // 助人榜单
  leaveBranch: `${QAAPI_HOST}/cantonal/quit`, // 退出分馆
  getTopicsRecommend: `${QAAPI_HOST}/topics/recommend`, // 话题故事 - 推荐话题
  writingPlanList: `${QAAPI_HOST}/cantonal/topics`, // 书写计划
  joinWritingPlan: `${QAAPI_HOST}/topics/prewriting`, // 参加书写计划
  writingPlanAward: `${QAAPI_HOST}/topics/award` // 书写计划 - 领取奖励
}



// WEBPACK FOOTER //
// ./src/pages/ask/askBranch/api.js